import * as types from './mutations_types'
// 微信名称转译
function doDeMemberName (val) {
  if (!val) {
    return ''
  }
  if (val.indexOf('[[') > -1 && val.indexOf(']]') > 1) {
    try {
      val = decodeURIComponent(val)
      val = val.split('[[').join('')
      val = val.split(']]').join('')
    } catch (e) {

    }
  }
  return val
}
export default {
  // 更新页面信息
  [types.UPDATE_PAGE_INFO] (state, pageInfo) {
    state.pageInfo = Object.assign(state.pageInfo, pageInfo)
  },
  // 更新用户信息
  [types.UPDATE_USER_INFO] (state, userInfo) {
    userInfo.memberName = doDeMemberName(userInfo.memberName)
    console.log('userInfo---:', userInfo)
    state.userInfo = Object.assign({}, userInfo)
  }
}



// WEBPACK FOOTER //
// ./src/store/global/mutations.js